import { getPocketBase, escFilter as esc } from '../pocketbase.js';

export async function fetchRoster(accessKey, auctionId, pbOverride) {
  const pb = pbOverride || getPocketBase();
  if (!auctionId) return [];
  return pb.collection('roster').getFullList({
    filter: `access_key="${esc(accessKey)}" && auction_id="${esc(auctionId)}"`,
  });
}

export async function upsertRosterPlayer({ accessKey, auctionId, playerKey, price }, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const data = {
    access_key: accessKey,
    auction_id: auctionId,
    player_key: playerKey,
    price: Number(price) || 0,
  };
  const existing = await pb.collection('roster').getFullList({
    filter: `access_key="${esc(accessKey)}" && auction_id="${esc(auctionId)}" && player_key="${esc(playerKey)}"`,
  });
  if (existing.length) return pb.collection('roster').update(existing[0].id, data);
  return pb.collection('roster').create(data);
}

export async function deleteRosterPlayer(accessKey, auctionId, playerKey, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const existing = await pb.collection('roster').getFullList({
    filter: `access_key="${esc(accessKey)}" && auction_id="${esc(auctionId)}" && player_key="${esc(playerKey)}"`,
  });
  for (const r of existing) await pb.collection('roster').delete(r.id);
  return { deleted: existing.length };
}
